import { P } from '../../../AbstractElements';
import { Febric, Video, Details, Discription1, Discription2, Discription3, Discription4, ProductDimensions, ProductDimensions2, DateFirstAvailable2, DateFirstAvailable, Manufacturer, ItemPartNumber, ItemPartNumber2, TeeStores } from '../../../Constant';
import React, { Fragment, useState } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import { BrandIcons } from '../../../Constant';
import useShowClass from '../../../Utils/Hooks/useAnimateClass';

const ClothsDetails = () => {
  const [activeTab, setActiveTab] = useState('1');
  const [show, setShow] = useShowClass('show', 100);
  const activeHandler = (active) => {
    setActiveTab(active);
    setShow('');
  };
  return (
    <Fragment>
      <Nav tabs className='border-tab border-0 mb-0'>
        <NavItem>
          <NavLink tag='button' className={activeTab === '1' ? 'active' : ''} onClick={() => activeHandler('1')}>
            {Febric}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink tag='button' className={activeTab === '2' ? 'active' : ''} onClick={() => activeHandler('2')}>
            {Video}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink tag='button' className={activeTab === '3' ? 'active' : ''} onClick={() => activeHandler('3')}>
            {Details}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink tag='button' className={activeTab === '4' ? 'active' : ''} onClick={() => activeHandler('4')}>
            {BrandIcons}
          </NavLink>
        </NavItem>
      </Nav>
      <TabContent activeTab={activeTab}>
        <TabPane className={`fade ${activeTab === '1' && show}`} tabId='1'>
          <P className='mb-0 m-t-20'>{Discription1}</P>
          <P className='mb-0 m-t-20'>{Discription2}</P>
        </TabPane>
        <TabPane className={`fade ${activeTab === '2' && show}`} tabId='2'>
          <P className='mb-0 m-t-20'>{Discription3}</P>
        </TabPane>
        <TabPane className={`fade ${activeTab === '3' && show}`} tabId='3'>
          <P className='mb-0 m-t-20'> {Discription4}</P>
        </TabPane>
        <TabPane className={`fade ${activeTab === '4' && show}`} tabId='4'>
          <P className='mb-0 m-t-20'>
            {ProductDimensions}:{ProductDimensions2} <br />
            {DateFirstAvailable} : {DateFirstAvailable2} <br />
            {Manufacturer} : {TeeStores}
            <br />
            {ItemPartNumber} : {ItemPartNumber2} <br />
          </P>
        </TabPane>
      </TabContent>
    </Fragment>
  );
};
export default ClothsDetails;
